import React from 'react';

function LinkedinIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='16' cy='16' r='16' fill='#F8F5EF' />
			<g clipPath='url(#clip0)'>
				<path
					d='M25.5952 25.5998V25.599H25.6V18.5574C25.6 15.1126 24.8584 12.459 20.8312 12.459C18.8952 12.459 17.596 13.5214 17.0656 14.5286H17.0096V12.7806H13.1912V25.599H17.1672V19.2518C17.1672 17.5806 17.484 15.9646 19.5536 15.9646C21.5928 15.9646 21.6232 17.8718 21.6232 19.359V25.5998H25.5952Z'
					fill='#CF004F'
				/>
				<path
					d='M6.7168 12.7815H10.6976V25.5999H6.7168V12.7815Z'
					fill='#CF004F'
				/>
				<path
					d='M8.7055 6.3999C7.4327 6.3999 6.3999 7.4327 6.3999 8.7055C6.3999 9.9783 7.4327 11.0327 8.7055 11.0327C9.9783 11.0327 11.0111 9.9783 11.0111 8.7055C11.0103 7.4327 9.9775 6.3999 8.7055 6.3999V6.3999Z'
					fill='#CF004F'
				/>
			</g>
			<defs>
				<clipPath id='clip0'>
					<rect
						width='19.2'
						height='19.2'
						fill='white'
						transform='translate(6.3999 6.3999)'
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default LinkedinIcon;
